import React, { createRef } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Card, Link, Tooltip } from '@mui/material'

import { getRoute, pageTypes, routePaths } from '../../../constants'
import { /* Logger, LoggerTypes */ DebugView } from '../../../utils'
import { ProjectButtonFavorite } from '../ProjectButtonFavorite'
import './style.scss'

export const ProjectCard = ({ currentProject, className }) => {
  const ref = createRef()
  const { t } = useTranslation()

  if (!currentProject) {
    return <></>
  }

  const { id, name, creation_date, last_update_date, scenario_count, description } = currentProject

  // Logger.trace(LoggerTypes.CONTAINER, 'ProjectCard.render()', { currentProject })

  return (
    (currentProject && (
      <Tooltip placement="right-start" enterDelay={500} enterNextDelay={500} ref={ref} title={description}>
        <Card className={`projectCard ${className}`}>
          <ProjectButtonFavorite className="button star" ref={ref} project={currentProject} />
          <img src="/images/project/eolienne.jpeg" className="icon" />
          <div className="desc">
            <Link className="projectNameLink" href={getRoute(routePaths.SCENARIO_LIST, { pid: id })}>
              <h3>{name}</h3>
            </Link>
            <DebugView type={pageTypes.PROJECT}>{currentProject}</DebugView>
            <p>
              {t('Created on:')} {creation_date}
              <br />
              {t('Last update:')} {last_update_date}
              <br />
              {scenario_count} scenarios
            </p>
          </div>
        </Card>
      </Tooltip>
    )) || <></>
  )
}

ProjectCard.displayName = 'ProjectCard'

ProjectCard.propTypes = {
  className: PropTypes.string,
  currentProject: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    creation_date: PropTypes.string.isRequired,
    last_update_date: PropTypes.string.isRequired,
    scenario_count: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired
  }).isRequired
}

ProjectCard.defaultProps = {
  className: '',
  currentProject: {
    id: '',
    name: '',
    description: '',
    creation_date: '',
    last_update_date: '',
    scenario_count: 0
  }
}
